import { UndergradDiscipline } from '@/models/undergrad/undergrad-discipline.model';

export interface UndergradDisciplineState {
  allDisciplinesIds: string[];
  undergradDisciplines: { [key: string]: UndergradDiscipline };
  currentDisciplinesByCycle: UndergradDiscipline[];
  isLoadingDisciplineData: { [disciplineId: string]: boolean };
  isLoadingDisciplineLives: { [disciplineId: string]: boolean };
}

const state: UndergradDisciplineState = {
  allDisciplinesIds: [],
  undergradDisciplines: {},
  currentDisciplinesByCycle: [],
  isLoadingDisciplineData: {},
  isLoadingDisciplineLives: {},
};

export default state;
